import { Component, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-svg',
  template: '<ng-content></ng-content>',
  styleUrls: ['./svg.component.scss']
})
export class SvgComponent implements OnInit, OnDestroy {
  @Input() public src!: string;

  private svgSub: Subscription;

  constructor(private element: ElementRef, private renderer: Renderer2, private httpClient: HttpClient) {
  }

  ngOnInit(): void {
    const elem = this.element.nativeElement;
    this.svgSub = this.httpClient.get(this.src, { responseType: 'text' }).subscribe(svg => {
      elem.innerHTML = svg;
    });
  }

  ngOnDestroy(): void {
    if ( this.svgSub) {
      this.svgSub.unsubscribe();
    }
  }

}
